<template>
  <div class="network com-padding-top-50 com-padding-bottom-90">
    <div class="com-content-1340">
      <div class="dn-upper">
        <div class="dn-left">
          <div class="dp-ti1">{{ dataDetail.title }}</div>
          <div class="dp-intr1">{{ dataDetail.recom }}</div>
          <div class="dp-phone1">
            Global unified customer service phone：<b> {{ dataDetail.kefu_tel }}</b>
          </div>
          <el-radio-group v-model="modelRadio" class="el-radio-group1">
            <el-radio-button label="1">
              <i class="iconfont icon-guonei"></i>Domestic sales
            </el-radio-button>
            <el-radio-button label="2">
              <i class="iconfont icon-shijieditu"></i>International sales
            </el-radio-button>
          </el-radio-group>

        </div>
        <div class="dn-right">
          <img :src="stateimgBaseURL+dataDetail.imga_path" alt=""
               class="dp-img1" v-if="modelRadio==1">
          <img :src="stateimgBaseURL+dataDetail.imgb_path" alt="" class="dp-img1" v-else>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  data() {
    return {
      dataDetail: '',
      modelRadio: '1',
    }
  },
  computed: {
    ...mapState(['stateimgBaseURL'])
  },
  created() {
    this.dataRequestusercenter_serviceNetwork()
  },
  methods: {
    // 服务网点
    dataRequestusercenter_serviceNetwork() {
      this.$api.user.usercenter_serviceNetwork().then(res => {
        this.dataDetail = res.data.info
      })
    },

  }
}
</script>

<style scoped lang="scss">
.network {
  .dn-upper {
    border: 1px solid $line1;
    padding: 60px;
    display: flex;

    .dn-left {
      width: 390px;

      .dp-ti1 {
        font-size: 30px;
        color: #333333;
        font-weight: 600;
      }

      .dp-intr1 {
        font-size: 16px;
        line-height: 30px;
        color: #999999;
        margin: 10px 0;
      }

      .dp-phone1 {
        font-size: 22px;
        color: #333333;
        display: flex;
        align-items: center;
        border-bottom: 2px solid #333333;
        margin: 0 0 60px;

        b {
          color: $color1;
          font-size: 28px;
        }
      }

      .el-radio-group1 {
        display: flex;
        flex-direction: column;
        width: 270px;

        .el-radio-button {
          border: 1px solid $line1;
          margin: 10px 0;
        }

        ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
          background: #676767;
        }

        ::v-deep .el-radio-button__inner {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          border: none;

          i {
            font-size: 36px;
            margin: 0 5px 0 0;
          }
        }
      }
    }

    .dn-right {
      flex: 1;
      padding: 0 0 0 135px;

      .dp-img1 {
        display: block;
        width: 100%;
      }
    }

  }
}

@media screen and (max-width: 768px) {
  .network {
    .dn-upper {
      padding: 60*$mobile-conversion;
      flex-wrap: wrap;

      .dn-left {
        width: 100%;

        .dp-ti1 {
          font-size: 38*$mobile-conversion;
        }

        .dp-intr1 {
          font-size: 26*$mobile-conversion;
          line-height: 40*$mobile-conversion;
          margin: 10*$mobile-conversion 0;
        }

        .dp-phone1 {
          font-size: 30*$mobile-conversion;
          margin: 0 0 60*$mobile-conversion;

          b {
            font-size: 36*$mobile-conversion;
          }
        }

        .el-radio-group1 {
          width: 270*$mobile-conversion;
          flex-direction: inherit;

          .el-radio-button {
            margin: 10*$mobile-conversion 0;
          }


          ::v-deep .el-radio-button__inner {
            font-size: 28*$mobile-conversion;

            i {
              font-size: 42*$mobile-conversion;
              margin: 0 5*$mobile-conversion 0 0;
            }
          }
        }
      }

      .dn-right {
        flex: inherit;
        width: 100%;
        padding: 0;
        margin: 20*$mobile-conversion 0 0;
      }

    }
  }
}
</style>
